import { fetcher } from '@commenda/utils';

import type { IExternalShare } from '../file-share/types';
import { FORM_SHARES_BASE_URL } from './helpers';
import type { ICreateFormShareRequest } from './types';

export const createFormShare = async (
  body: ICreateFormShareRequest
): Promise<{ share: IExternalShare }> => {
  const res = await fetcher(FORM_SHARES_BASE_URL, { method: 'POST', body });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to create form share link.');
  }

  return await res.json();
};
